var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_910_8843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1124 18.6667H6.89019M13.1124 18.6667V13.0953V5.79052C13.1124 5.5935 13.0469 5.40455 12.9302 5.26524C12.8135 5.12592 12.6552 5.04766 12.4902 5.04766H7.51241C7.34739 5.04766 7.18912 5.12592 7.07243 5.26524C6.95575 5.40455 6.89019 5.5935 6.89019 5.79052V18.6667M13.1124 18.6667H18.7124C18.8774 18.6667 19.0357 18.5884 19.1524 18.4491C19.2691 18.3098 19.3346 18.1209 19.3346 17.9239V13.8381C19.3346 13.6411 19.2691 13.4522 19.1524 13.3129C19.0357 13.1735 18.8774 13.0953 18.7124 13.0953H13.7346C13.5696 13.0953 13.4113 13.1735 13.2947 13.3129C13.178 13.4522 13.1124 13.6411 13.1124 13.8381V18.6667ZM6.89019 18.6667V11.3619C6.89019 11.1649 6.82464 10.976 6.70795 10.8367C6.59126 10.6974 6.43299 10.6191 6.26797 10.6191H1.29019C1.12517 10.6191 0.966903 10.6974 0.850213 10.8367C0.733524 10.976 0.667969 11.1649 0.667969 11.3619V17.9239C0.667969 18.1209 0.733524 18.3098 0.850213 18.4491C0.966903 18.5884 1.12517 18.6667 1.29019 18.6667H6.89019ZM13.1124 1.33337H6.89019",
    stroke: "#212121",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_910_8843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.e856d9e4d2093d709ce84c338853b173.svg";
export { ForwardRef as ReactComponent };